'use strict';

function defaultNewDate() {
  return new Date;
}

module.exports = defaultNewDate;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/defaultNewDate.js
// module id = 517
// module chunks = 0